import React, { useState, useEffect } from "react";
import Footer from "../component/Footer";
import Compétences from "../assets/Compétences.svg";
import undraw_Design from "../assets/undraw_Design.svg"
import no_image from "../assets/no_image.png";
import messages from "../assets/messages.svg";
import matries from "../assets/matries.svg";
import { useParams } from "react-router-dom";
import axios from "axios";
import EditNoteIcon from '@mui/icons-material/EditNote';
import { Link } from "react-router-dom";
import Mapbox from "../component/mapbox/Mapbox";
import MessageProFormComp from "../component/messageProForm";
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { decodedStringValue } from "../_helpers";
import Breadcrumb from "./Directory/Breadcrumb";
import PageLoaderComp from "../component/pageLoaderComp";
import ToastMessageComp from "../component/ToastMessageComp";
import { useDispatch, useSelector } from 'react-redux';
import VerifiedIcon from '@mui/icons-material/Verified';


export default function FicheExpertsComptable() {
  const alert = useSelector(state => state.alert);
  const { id,name } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [loadingFullpage, setLoadingFullpage] = useState(false);
  const [singleList, setSingleList] = useState(null);
  const [data, setData] = useState([]);
  const [logo, setLogo] = useState(no_image);
  const [successfull, setSuccessfull] = useState(false);
  const [geoJson, setGeoJson] = useState({
    "type": "FeatureCollection",
    "features": []
  });
  const [latlng, setLatlng] = useState({
    "latitude":48.864716,
    "longitude":2.349014,
  });
  const [breadcrumbsData, setBreadcrumbsData] = useState({
    "breadCrumbs":[
      {"pagename":"Experts comptables","path":"/experts-comptables"}
    ],
    "main":{"pagename":((name).split("-")).join(" "),"path":"/"}
  });
  // Use Effect
  useEffect(() => {
    setLoadingFullpage(true);
    setBreadcrumbsData({
      "breadCrumbs":[
        {"pagename":"Experts comptables","path":"/experts-comptables"}
      ],
      "main":{"pagename":((name).split("-")).join(" "),"path":"/"}
    })
    
    let URL =
      process.env.REACT_APP_API_URL +
      "api/admin/get-directory-accountant/"+name+"/"+
      id;
    /* let config = {
      method: "get",
      url: URL,
    }; */
    // let URL = 'https://enterprise-search.kifwat.net/api/as/v1/engines/directory-accountant/search';
    /* let data = JSON.stringify({
      "query": name,
      "filters": {
        "id": id
      }
    }); */
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: URL,
      headers: { 
        // 'Authorization': `Bearer ${process.env.REACT_APP_ELK_SEARCH_API_KEY}`,
        // 'Accept': '*/*', 
        // "Cache-Control":"no-cache",
        'Content-Type': 'application/json', 
      },
      // data : data
    };

    axios
      .request(config)
      .then((response) => {
        
        // console.log("response.data",response.data);
        let jsonData = [];
        if((response.data.data).length>0){
          response.data.data.map((valData,i)=>{
            let val = valData._source;
              if(val.longitude && val.latitude){
                jsonData.push({
                  "type": "Feature",
                  "geometry": {
                    "type": "Point",
                    "coordinates": [parseFloat(val.longitude),parseFloat(val.latitude)]
                  }
                })
                setLatlng({
                  "latitude":parseFloat(val.latitude),
                  "longitude":parseFloat(val.longitude),
                })
              }
             
              let languagesArr = [];
              let openingHoursArr = [
                {
                  "dayName":"Lundi",
                  "openingHours":"9:00 - 18:00"
                },{
                  "dayName":"Mardi",
                  "openingHours":"9:00 - 18:00"
                },{
                  "dayName":"Mercredi",
                  "openingHours":"9:00 - 18:00"
                },{
                  "dayName":"Jeudi",
                  "openingHours":"9:00 - 18:00"
                },{
                  "dayName":"Vendredi",
                  "openingHours":"9:00 - 18:00"
                }/* ,{
                  "dayName":"Samedi",
                  "openingHours":"9:00 - 18:00"
                } */
              ];
              
              if(val.languages){
                languagesArr.push((val.languages).split(","))
              }
              val.languagesArr = languagesArr;
              
              if(val.openinghoursspecification){
                  // console.log("openinghoursspecification",val.openinghoursspecification)
                  // let openingHoursArrGetData = val.openinghoursspecification;
                  /* let openingHoursArrGet = JSON.parse(openingHoursArrGetData);

                  openingHoursArrGet.map((valArr,keyArr)=>{
                    valArr.dayOfWeek.map((valWeek,keyWeek)=>{
                      let findIndex = openingHoursArr.findIndex(dayval=>dayval.dayName==valWeek);
                      if(findIndex >=0){
                        let openingHoursArr_get = openingHoursArr[findIndex];
                        let openingHoursGet = openingHoursArr_get.openingHours;
                        let openingHoursGetArr = openingHoursGet.split(",");
                        openingHoursGetArr.push(valArr.opens+"- "+valArr.closes);
                        openingHoursArr[findIndex].openingHours = openingHoursGetArr.join(",")
                      }                        
                    })
                    
                  }) */
              }
              val.openingHoursArr = openingHoursArr;             
              let decodedString = decodedStringValue(val.name);
              val.name = decodedString;
              // console.log(decodedString);
              return val;
          })
          setGeoJson({
            "type": "FeatureCollection",
            "features": jsonData
          });
          
          setData(response.data.data);
        }else{
          setData(response.data.data);
        }
        
        let cleanedStr = "";
        let array = [];
        let url = no_image;
        if(response.data.data && response.data.data[0]._source && response.data.data[0]._source.logo ){
          cleanedStr = response.data.data[0]._source.logo.replace(/^\[('|")?|('|")?\]$/g, "");
          array = cleanedStr.split(",");
          url = array[0].trim();
          
        }
        setLogo(url);

        if(response.data.data && response.data.data.length>0){
          setBreadcrumbsData({
            "breadCrumbs":[
              {"pagename":"Experts comptables","path":"/experts-comptables"},
              {"pagename":(response.data.data[0]._source.addresslocality).toLowerCase(),"path":`/annuaire-des-experts-comptable-selection/accountants/${(response.data.data[0]._source.addresslocality).toLowerCase()}`}
            ],
            "main":{"pagename":((name).split("-")).join(" "),"path":"/"}
          })          
        }
        setLoadingFullpage(false);
      })
      .catch((error) => {
        setLoadingFullpage(false);
        console.log(error);
      });
  }, [name,id]);
  const filterData = [
    {
      "name":"Présentation",
      "id":"presentation",
    },
    {
      "name":"Métiers",
      "id":"metiers",
    },
    {
      "name":"Compétences",
      "id":"competences",
    },
    {
      "name":"Secteurs",
      "id":"Secteurs",
    },
    {
      "name":"Langues",
      "id":"langues",
    },
    {
      "name":"Infos pratiques",
      "id":"infos_pratiques",
    }
  ];
  // console.log("data",data)
  const handleOpenMessage = (event,list) => {
    // console.log("handleOpenMessage")
    setIsOpen(true)
    setSingleList(list)
  };
  return (
    <>
      <MessageProFormComp isOpen={isOpen} setSuccessfull={setSuccessfull} setIsOpen={setIsOpen} singleList={singleList} type={"accountant"} />
      {loadingFullpage?
      <PageLoaderComp />
      :""}
      {successfull?
        <ToastMessageComp  message={alert.message} type={alert.type} />
        :""}
      <div className="bg-mainBg">
        <div
          className="w-full min-h-[201px]"
          style={{
            background: "linear-gradient(90.63deg, #27295B 0%, #1CBE93 100%)",
          }}
        >
          <div  className={loadingFullpage?"hidden":"flex items-center justify-start sm:gap-4 pt-5 pb-5  px-6 w-full m-auto"}>
            <Breadcrumb page="Experts-comptables" breadcrumbsData={breadcrumbsData} />
          </div>
          <div className="md:max-w-[1200px] relative w-full h-full  m-auto  py-7  px-6 sm:px-4">
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <img src={logo} alt={logo} />
              <div>
                <h4 className="font-bold text-lg 3xl:text-xl text-white">
                Cabinet {data.length>0 && decodedStringValue(data[0]._source.name).toUpperCase()}  
                {
                  data.length>0 && data[0]._source.partner_status ==="approved"?
                  <span style={{ color: "green", marginLeft: "8px" }}><VerifiedIcon color="success" /></span>
                  : data.length>0 && data[0]._source.partner_status ==="gold" ?<span style={{ color: "green", marginLeft: "8px" }}><VerifiedIcon style={{"color":"gold"}}  /></span>:""
                  }
                </h4>
                <h6 className="text-base font-semibold text-white">
                  {data.length>0 && decodedStringValue(data[0]._source.streetaddress).toLowerCase()}                   
                </h6>
                
                <h6 className="text-base font-semibold text-white">
                {data.length>0 && decodedStringValue(data[0]._source.addresslocality).toUpperCase()} {data.length>0 && "("+data[0]._source.postalcode+")"}
                  
                </h6>
                {/* <p className="text-base font-light text-white">
                  Expert-comptable - Commissaire aux comptes
                </p> */}
                {/* <div className="flex items-center gap-4">
                  <p className="text-[12px] font-normal text-white">
                    N° Ordre des Experts-Comptables{" "}
                  </p>
                  <p className="text-[12px] font-normal text-white">
                    14-01305000-01
                  </p>
                </div> */}
                {/* <div className="flex items-center gap-4">
                  <p className="text-[12px] font-normal text-white">
                    N° Compagnie des Commissaires aux Comptes{" "}
                  </p>
                  <p className="text-[12px] font-normal text-white">66005840</p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div className="w-full px-5 2xl:px-14 3xl:px-48 m-auto py-5 bg-white flex flex-col xl:flex-row gap-5  items-center justify-between">
          <div className="flex items-center xl:gap-5 w-full flex-wrap">
            <ul className="flex items-center gap-3 justify-between w-full xl:gap-12 flex-wrap">
              {filterData.map((item, i) => {
                return (
                  <li key={i} className="text-base text-primary font-light">                    
                    <AnchorLink offset='100' href={`${"#"+item.id}`}>{item.name}</AnchorLink>
                  </li>
                );
              })}
            </ul>
          </div>
          <div>
            <div className="flex items-center gap-2">
              <Link to="">
                <svg
                  width="28"
                  height="29"
                  viewBox="0 0 28 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width="27.9259"
                    height="27.9259"
                    rx="5"
                    fill="#27295B"
                  />
                  <path
                    d="M17.4306 12.9604C17.4912 12.4604 17.5366 11.9603 17.5366 11.4451C17.5366 10.9299 17.4912 10.4299 17.4306 9.92982H19.9914C20.1126 10.4147 20.1884 10.9223 20.1884 11.4451C20.1884 11.9679 20.1126 12.4755 19.9914 12.9604M16.0895 17.1729C16.5441 16.3319 16.8926 15.4227 17.1351 14.4757H19.3701C18.6361 15.7397 17.4716 16.6971 16.0895 17.1729ZM15.9001 12.9604H12.3543C12.2786 12.4604 12.2331 11.9603 12.2331 11.4451C12.2331 10.9299 12.2786 10.4223 12.3543 9.92982H15.9001C15.9683 10.4223 16.0214 10.9299 16.0214 11.4451C16.0214 11.9603 15.9683 12.4604 15.9001 12.9604ZM14.1272 17.476C13.4984 16.5668 12.9908 15.5591 12.6801 14.4757H15.5743C15.2637 15.5591 14.7561 16.5668 14.1272 17.476ZM11.0967 8.41453H8.88433C9.6108 7.14715 10.7745 6.18817 12.1574 5.71731C11.7028 6.55829 11.3618 7.46747 11.0967 8.41453ZM8.88433 14.4757H11.0967C11.3618 15.4227 11.7028 16.3319 12.1574 17.1729C10.7774 16.6969 9.61534 15.7392 8.88433 14.4757ZM8.26306 12.9604C8.14184 12.4755 8.06607 11.9679 8.06607 11.4451C8.06607 10.9223 8.14184 10.4147 8.26306 9.92982H10.8239C10.7633 10.4299 10.7178 10.9299 10.7178 11.4451C10.7178 11.9603 10.7633 12.4604 10.8239 12.9604M14.1272 5.40667C14.7561 6.31585 15.2637 7.33109 15.5743 8.41453H12.6801C12.9908 7.33109 13.4984 6.31585 14.1272 5.40667ZM19.3701 8.41453H17.1351C16.898 7.47615 16.5468 6.57034 16.0895 5.71731C17.4836 6.19462 18.6428 7.15683 19.3701 8.41453ZM14.1272 3.86865C9.93746 3.86865 6.55078 7.27806 6.55078 11.4451C6.55078 13.4545 7.34901 15.3816 8.76987 16.8025C9.47341 17.506 10.3086 18.0641 11.2279 18.4448C12.1471 18.8256 13.1323 19.0216 14.1272 19.0216C16.1366 19.0216 18.0637 18.2233 19.4846 16.8025C20.9055 15.3816 21.7037 13.4545 21.7037 11.4451C21.7037 10.4502 21.5077 9.46494 21.127 8.54572C20.7462 7.62651 20.1881 6.79128 19.4846 6.08775C18.7811 5.38421 17.9458 4.82613 17.0266 4.44538C16.1074 4.06462 15.1222 3.86865 14.1272 3.86865Z"
                    fill="white"
                  />
                  <path
                    d="M4.6 26L3.032 21.728H3.976L5.32 25.496H4.872L6.28 21.728H7.12L8.488 25.496H8.048L9.432 21.728H10.32L8.744 26H7.784L6.536 22.664H6.832L5.56 26H4.6ZM11.8656 26L10.2976 21.728H11.2416L12.5856 25.496H12.1376L13.5456 21.728H14.3856L15.7536 25.496H15.3136L16.6976 21.728H17.5856L16.0096 26H15.0496L13.8016 22.664H14.0976L12.8256 26H11.8656ZM19.1313 26L17.5633 21.728H18.5073L19.8513 25.496H19.4033L20.8113 21.728H21.6513L23.0193 25.496H22.5793L23.9633 21.728H24.8513L23.2753 26H22.3153L21.0673 22.664H21.3633L20.0913 26H19.1313Z"
                    fill="white"
                  />
                </svg>
              </Link>
              <Link to="">
                <svg
                  width="29"
                  height="28"
                  viewBox="0 0 29 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask id="path-1-inside-1_3689_2655" fill="white">
                    <path d="M17.568 21.2419V18.4036C17.568 17.801 17.3932 17.4997 17.0437 17.4997C16.8388 17.4997 16.64 17.5961 16.4471 17.7889V21.8385C16.64 22.0313 16.8388 22.1277 17.0437 22.1277C17.3932 22.1277 17.568 21.8324 17.568 21.2419ZM20.8944 19.0363H22.0875V18.4217C22.0875 17.807 21.8887 17.4997 21.4909 17.4997C21.0932 17.4997 20.8944 17.807 20.8944 18.4217V19.0363ZM10.5717 14.2275V15.493H9.12545V23.1401H7.78766V15.493H6.37756V14.2275H10.5717ZM14.2054 16.5054V23.1401H12.9942V22.417C12.5242 22.9593 12.0662 23.2305 11.6202 23.2305C11.2225 23.2305 10.9694 23.0618 10.861 22.7243C10.7886 22.5194 10.7525 22.194 10.7525 21.7481V16.5054H11.9456V21.3865C11.9456 21.6758 11.9517 21.8324 11.9637 21.8565C11.9758 22.0373 12.0662 22.1277 12.2349 22.1277C12.4759 22.1277 12.729 21.9409 12.9942 21.5673V16.5054H14.2054ZM18.7611 18.5121V21.1515C18.7611 21.7782 18.7189 22.2181 18.6346 22.4712C18.49 22.9774 18.1706 23.2305 17.6764 23.2305C17.2546 23.2305 16.8448 22.9834 16.4471 22.4893V23.1401H15.2359V14.2275H16.4471V17.1381C16.8328 16.656 17.2426 16.415 17.6764 16.415C18.1706 16.415 18.49 16.6681 18.6346 17.1743C18.7189 17.4274 18.7611 17.8733 18.7611 18.5121ZM23.2988 20.8442V21.0069C23.2988 21.3564 23.2867 21.6155 23.2626 21.7842C23.2264 22.0494 23.1361 22.2904 22.9914 22.5074C22.666 22.9894 22.1839 23.2305 21.5452 23.2305C20.9185 23.2305 20.4304 23.0015 20.0808 22.5435C19.8277 22.2181 19.7012 21.6999 19.7012 20.9888V18.6567C19.7012 17.9456 19.8217 17.4274 20.0628 17.102C20.4123 16.644 20.8944 16.415 21.509 16.415C22.1237 16.415 22.5937 16.644 22.9191 17.102C23.1722 17.4515 23.2988 17.9697 23.2988 18.6567V20.0306H20.8944V21.2057C20.8944 21.8204 21.0992 22.1277 21.509 22.1277C21.7983 22.1277 21.9791 21.971 22.0514 21.6577C22.0514 21.6456 22.0544 21.6034 22.0604 21.5311C22.0664 21.4588 22.0694 21.3594 22.0694 21.2328V20.8442H23.2988ZM15.1455 5.94773V8.76793C15.1455 9.38259 14.9527 9.68991 14.567 9.68991C14.1813 9.68991 13.9885 9.38259 13.9885 8.76793V5.94773C13.9885 5.32102 14.1813 5.00766 14.567 5.00766C14.9527 5.00766 15.1455 5.32102 15.1455 5.94773ZM24.7812 18.8375C24.7812 16.7043 24.6667 15.1375 24.4377 14.1372C24.3172 13.6069 24.058 13.1639 23.6603 12.8084C23.2626 12.4529 22.8046 12.245 22.2864 12.1847C20.6473 12.0039 18.1646 11.9135 14.8382 11.9135C11.5238 11.9135 9.04711 12.0039 7.40802 12.1847C6.87773 12.245 6.41673 12.4529 6.02504 12.8084C5.63334 13.1639 5.37723 13.6069 5.25671 14.1372C5.01567 15.1857 4.89515 16.7525 4.89515 18.8375C4.89515 20.9587 5.01567 22.5254 5.25671 23.5378C5.37723 24.0561 5.63334 24.496 6.02504 24.8575C6.41673 25.2191 6.8717 25.43 7.38994 25.4903C9.04108 25.671 11.5238 25.7614 14.8382 25.7614C18.1525 25.7614 20.6352 25.671 22.2864 25.4903C22.8046 25.43 23.2596 25.2191 23.6513 24.8575C24.043 24.496 24.2991 24.0561 24.4196 23.5378C24.6607 22.5254 24.7812 20.9587 24.7812 18.8375ZM11.1321 7.06858L12.7592 1.71743H11.4033L10.4813 5.24268L9.52317 1.71743H8.11307C8.19743 1.99463 8.33603 2.41043 8.52887 2.96482L8.96275 4.21222C9.38457 5.45359 9.66177 6.40571 9.79434 7.06858V10.7023H11.1321V7.06858ZM16.3567 8.53291V6.18274C16.3567 5.48372 16.2302 4.95945 15.9771 4.60994C15.6276 4.15196 15.1575 3.92297 14.567 3.92297C13.9523 3.92297 13.4823 4.15196 13.1569 4.60994C12.9038 4.95945 12.7772 5.48372 12.7772 6.18274V8.53291C12.7772 9.23193 12.9038 9.7562 13.1569 10.1057C13.4823 10.5637 13.9523 10.7927 14.567 10.7927C15.1575 10.7927 15.6276 10.5637 15.9771 10.1057C16.2302 9.78031 16.3567 9.25604 16.3567 8.53291ZM19.6289 10.7023H20.8401V4.01336H19.6289V9.12949C19.3637 9.50311 19.1106 9.68991 18.8696 9.68991C18.6888 9.68991 18.5924 9.5935 18.5803 9.40066C18.5683 9.37656 18.5623 9.21988 18.5623 8.93063V4.01336H17.351V9.31027C17.351 9.7562 17.3872 10.0876 17.4595 10.3046C17.5921 10.63 17.8512 10.7927 18.2369 10.7927C18.6707 10.7927 19.1347 10.5215 19.6289 9.97917V10.7023ZM28.7222 5.20652V22.5616C28.7222 23.9958 28.213 25.2221 27.1946 26.2405C26.1762 27.2589 24.9499 27.7681 23.5157 27.7681H6.16062C4.72642 27.7681 3.50011 27.2589 2.48171 26.2405C1.4633 25.2221 0.954102 23.9958 0.954102 22.5616V5.20652C0.954102 3.77232 1.4633 2.54601 2.48171 1.52761C3.50011 0.509203 4.72642 0 6.16062 0H23.5157C24.9499 0 26.1762 0.509203 27.1946 1.52761C28.213 2.54601 28.7222 3.77232 28.7222 5.20652Z" />
                  </mask>
                  <path
                    d="M17.568 21.2419V18.4036C17.568 17.801 17.3932 17.4997 17.0437 17.4997C16.8388 17.4997 16.64 17.5961 16.4471 17.7889V21.8385C16.64 22.0313 16.8388 22.1277 17.0437 22.1277C17.3932 22.1277 17.568 21.8324 17.568 21.2419ZM20.8944 19.0363H22.0875V18.4217C22.0875 17.807 21.8887 17.4997 21.4909 17.4997C21.0932 17.4997 20.8944 17.807 20.8944 18.4217V19.0363ZM10.5717 14.2275V15.493H9.12545V23.1401H7.78766V15.493H6.37756V14.2275H10.5717ZM14.2054 16.5054V23.1401H12.9942V22.417C12.5242 22.9593 12.0662 23.2305 11.6202 23.2305C11.2225 23.2305 10.9694 23.0618 10.861 22.7243C10.7886 22.5194 10.7525 22.194 10.7525 21.7481V16.5054H11.9456V21.3865C11.9456 21.6758 11.9517 21.8324 11.9637 21.8565C11.9758 22.0373 12.0662 22.1277 12.2349 22.1277C12.4759 22.1277 12.729 21.9409 12.9942 21.5673V16.5054H14.2054ZM18.7611 18.5121V21.1515C18.7611 21.7782 18.7189 22.2181 18.6346 22.4712C18.49 22.9774 18.1706 23.2305 17.6764 23.2305C17.2546 23.2305 16.8448 22.9834 16.4471 22.4893V23.1401H15.2359V14.2275H16.4471V17.1381C16.8328 16.656 17.2426 16.415 17.6764 16.415C18.1706 16.415 18.49 16.6681 18.6346 17.1743C18.7189 17.4274 18.7611 17.8733 18.7611 18.5121ZM23.2988 20.8442V21.0069C23.2988 21.3564 23.2867 21.6155 23.2626 21.7842C23.2264 22.0494 23.1361 22.2904 22.9914 22.5074C22.666 22.9894 22.1839 23.2305 21.5452 23.2305C20.9185 23.2305 20.4304 23.0015 20.0808 22.5435C19.8277 22.2181 19.7012 21.6999 19.7012 20.9888V18.6567C19.7012 17.9456 19.8217 17.4274 20.0628 17.102C20.4123 16.644 20.8944 16.415 21.509 16.415C22.1237 16.415 22.5937 16.644 22.9191 17.102C23.1722 17.4515 23.2988 17.9697 23.2988 18.6567V20.0306H20.8944V21.2057C20.8944 21.8204 21.0992 22.1277 21.509 22.1277C21.7983 22.1277 21.9791 21.971 22.0514 21.6577C22.0514 21.6456 22.0544 21.6034 22.0604 21.5311C22.0664 21.4588 22.0694 21.3594 22.0694 21.2328V20.8442H23.2988ZM15.1455 5.94773V8.76793C15.1455 9.38259 14.9527 9.68991 14.567 9.68991C14.1813 9.68991 13.9885 9.38259 13.9885 8.76793V5.94773C13.9885 5.32102 14.1813 5.00766 14.567 5.00766C14.9527 5.00766 15.1455 5.32102 15.1455 5.94773ZM24.7812 18.8375C24.7812 16.7043 24.6667 15.1375 24.4377 14.1372C24.3172 13.6069 24.058 13.1639 23.6603 12.8084C23.2626 12.4529 22.8046 12.245 22.2864 12.1847C20.6473 12.0039 18.1646 11.9135 14.8382 11.9135C11.5238 11.9135 9.04711 12.0039 7.40802 12.1847C6.87773 12.245 6.41673 12.4529 6.02504 12.8084C5.63334 13.1639 5.37723 13.6069 5.25671 14.1372C5.01567 15.1857 4.89515 16.7525 4.89515 18.8375C4.89515 20.9587 5.01567 22.5254 5.25671 23.5378C5.37723 24.0561 5.63334 24.496 6.02504 24.8575C6.41673 25.2191 6.8717 25.43 7.38994 25.4903C9.04108 25.671 11.5238 25.7614 14.8382 25.7614C18.1525 25.7614 20.6352 25.671 22.2864 25.4903C22.8046 25.43 23.2596 25.2191 23.6513 24.8575C24.043 24.496 24.2991 24.0561 24.4196 23.5378C24.6607 22.5254 24.7812 20.9587 24.7812 18.8375ZM11.1321 7.06858L12.7592 1.71743H11.4033L10.4813 5.24268L9.52317 1.71743H8.11307C8.19743 1.99463 8.33603 2.41043 8.52887 2.96482L8.96275 4.21222C9.38457 5.45359 9.66177 6.40571 9.79434 7.06858V10.7023H11.1321V7.06858ZM16.3567 8.53291V6.18274C16.3567 5.48372 16.2302 4.95945 15.9771 4.60994C15.6276 4.15196 15.1575 3.92297 14.567 3.92297C13.9523 3.92297 13.4823 4.15196 13.1569 4.60994C12.9038 4.95945 12.7772 5.48372 12.7772 6.18274V8.53291C12.7772 9.23193 12.9038 9.7562 13.1569 10.1057C13.4823 10.5637 13.9523 10.7927 14.567 10.7927C15.1575 10.7927 15.6276 10.5637 15.9771 10.1057C16.2302 9.78031 16.3567 9.25604 16.3567 8.53291ZM19.6289 10.7023H20.8401V4.01336H19.6289V9.12949C19.3637 9.50311 19.1106 9.68991 18.8696 9.68991C18.6888 9.68991 18.5924 9.5935 18.5803 9.40066C18.5683 9.37656 18.5623 9.21988 18.5623 8.93063V4.01336H17.351V9.31027C17.351 9.7562 17.3872 10.0876 17.4595 10.3046C17.5921 10.63 17.8512 10.7927 18.2369 10.7927C18.6707 10.7927 19.1347 10.5215 19.6289 9.97917V10.7023ZM28.7222 5.20652V22.5616C28.7222 23.9958 28.213 25.2221 27.1946 26.2405C26.1762 27.2589 24.9499 27.7681 23.5157 27.7681H6.16062C4.72642 27.7681 3.50011 27.2589 2.48171 26.2405C1.4633 25.2221 0.954102 23.9958 0.954102 22.5616V5.20652C0.954102 3.77232 1.4633 2.54601 2.48171 1.52761C3.50011 0.509203 4.72642 0 6.16062 0H23.5157C24.9499 0 26.1762 0.509203 27.1946 1.52761C28.213 2.54601 28.7222 3.77232 28.7222 5.20652Z"
                    fill="#27295B"
                    stroke="#27295B"
                    strokeWidth="2"
                    mask="url(#path-1-inside-1_3689_2655)"
                  />
                </svg>
              </Link>
              <Link to="">
                <svg
                  width="29"
                  height="28"
                  viewBox="0 0 29 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.775879 2.32957C0.775879 1.71173 1.02131 1.1192 1.45819 0.682317C1.89507 0.245439 2.48761 3.10564e-06 3.10545 3.10564e-06H26.3276C26.6338 -0.000496967 26.9371 0.0593993 27.2201 0.176263C27.5031 0.293126 27.7602 0.464661 27.9769 0.681048C28.1935 0.897434 28.3653 1.15442 28.4825 1.4373C28.5996 1.72018 28.6599 2.02339 28.6597 2.32957V25.5517C28.66 25.858 28.6 26.1613 28.483 26.4443C28.366 26.7273 28.1943 26.9845 27.9778 27.2011C27.7613 27.4177 27.5043 27.5895 27.2213 27.7066C26.9384 27.8238 26.6351 27.884 26.3289 27.8838H3.10545C2.79942 27.8838 2.49638 27.8235 2.21367 27.7064C1.93095 27.5892 1.67408 27.4175 1.45775 27.2011C1.24141 26.9846 1.06984 26.7276 0.952843 26.4449C0.835846 26.1621 0.775713 25.859 0.775879 25.553V2.32957ZM11.8128 10.6313H15.5885V12.5274C16.1335 11.4374 17.5277 10.4564 19.6228 10.4564C23.6393 10.4564 24.5912 12.6276 24.5912 16.6112V23.9902H20.5265V17.5186C20.5265 15.2499 19.9815 13.9698 18.5974 13.9698C16.6773 13.9698 15.8788 15.35 15.8788 17.5186V23.9902H11.8128V10.6313ZM4.84185 23.8166H8.90781V10.4564H4.84185V23.8166ZM9.48957 6.09895C9.49724 6.44709 9.43529 6.79324 9.30736 7.11711C9.17944 7.44098 8.98811 7.73603 8.74461 7.98495C8.50111 8.23388 8.21034 8.43165 7.88936 8.56668C7.56839 8.70171 7.22368 8.77126 6.87546 8.77126C6.52725 8.77126 6.18254 8.70171 5.86156 8.56668C5.54059 8.43165 5.24982 8.23388 5.00632 7.98495C4.76282 7.73603 4.57149 7.44098 4.44356 7.11711C4.31564 6.79324 4.25369 6.44709 4.26136 6.09895C4.2764 5.41562 4.55843 4.76534 5.04703 4.28738C5.53563 3.80942 6.19196 3.54178 6.87546 3.54178C7.55897 3.54178 8.2153 3.80942 8.7039 4.28738C9.1925 4.76534 9.47452 5.41562 9.48957 6.09895Z"
                    fill="#27295B"
                  />
                </svg>
              </Link>
              <Link to="">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.1406 16.6432C19.1406 15.6953 18.9705 14.8021 18.6302 13.9635C18.1319 14.2674 17.6155 14.474 17.0807 14.5833C17.3481 15.191 17.4818 15.8837 17.4818 16.6615C17.4818 18.0833 17.0139 19.2895 16.0781 20.2799C15.1424 21.2704 13.9696 21.7656 12.5599 21.7656C11.1502 21.7656 9.97439 21.2704 9.03255 20.2799C8.09071 19.2895 7.61979 18.0833 7.61979 16.6615C7.61979 15.2639 8.09375 14.0516 9.04167 13.0247C9.98958 11.9978 11.1623 11.4844 12.5599 11.4844C13.204 11.4844 13.7995 11.5998 14.3464 11.8307C14.395 11.3082 14.559 10.7795 14.8385 10.2448C14.1094 9.98958 13.3498 9.86198 12.5599 9.86198C10.6884 9.86198 9.1237 10.5213 7.86589 11.8398C6.60807 13.1584 5.97917 14.7595 5.97917 16.6432C5.97917 18.5269 6.60807 20.1128 7.86589 21.401C9.1237 22.6892 10.6884 23.3333 12.5599 23.3333C14.4314 23.3333 15.9961 22.6862 17.2539 21.3919C18.5117 20.0977 19.1406 18.5148 19.1406 16.6432ZM15.8958 10.1719C15.9201 10.4635 15.9323 10.895 15.9323 11.4661C15.9323 12.2318 15.9019 12.9792 15.8411 13.7083C15.7804 14.4375 15.6558 15.2426 15.4674 16.1237C15.2791 17.0048 15.033 17.7947 14.7292 18.4935C14.4253 19.1923 14.0091 19.8364 13.4805 20.4258C12.9518 21.0152 12.3411 21.4436 11.6484 21.7109C11.9036 21.7474 12.1589 21.7656 12.4141 21.7656H12.5964C15.2578 20.0764 16.5885 17.579 16.5885 14.2734C16.5885 12.8637 16.3576 11.4965 15.8958 10.1719ZM15.8958 10.1719C15.8472 9.19965 15.5799 8.15755 15.0937 7.04557C14.6076 5.93359 14.0122 5.14062 13.3073 4.66667C14.4253 6.5625 15.2882 8.39757 15.8958 10.1719ZM22.0026 8.25781C22.0026 7.01823 21.6927 5.96094 21.0729 5.08594C20.5747 6.13108 19.8212 6.7934 18.8125 7.07292C17.974 7.30382 17.3116 7.62891 16.8255 8.04818C16.3394 8.46745 16.0964 9.07205 16.0964 9.86198C16.0964 10.3481 16.2422 10.816 16.5339 11.2656C17.4332 11.059 18.2869 10.6519 19.0951 10.0443C19.9032 9.43663 20.4835 8.73785 20.8359 7.94792C20.7873 8.57986 20.3346 9.25738 19.4779 9.98047C18.6211 10.7036 17.7795 11.296 16.9531 11.7578C17.5851 12.3898 18.2535 12.7057 18.9583 12.7057C19.5781 12.7057 20.125 12.4809 20.599 12.0312C21.0729 11.5816 21.4375 11.0347 21.6927 10.3906C21.8993 9.88021 22.0026 9.16927 22.0026 8.25781ZM28 5.25V22.75C28 24.1962 27.4865 25.4327 26.4596 26.4596C25.4327 27.4865 24.1962 28 22.75 28H5.25C3.80382 28 2.56727 27.4865 1.54036 26.4596C0.513455 25.4327 0 24.1962 0 22.75V5.25C0 3.80382 0.513455 2.56727 1.54036 1.54036C2.56727 0.513455 3.80382 0 5.25 0H22.75C24.1962 0 25.4327 0.513455 26.4596 1.54036C27.4865 2.56727 28 3.80382 28 5.25Z"
                    fill="#27295B"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </div>
        <div className="md:max-w-[1200px] relative w-full h-full  m-auto  py-7  px-4 sm:px-4">
          <div className="grid grid-cols-12 gap-8">
            <div className="col-span-12 2lg:col-span-8">
              <div className="bg-white rounded-md p-6" id={filterData[0].id}>
                <div className="flex gap-2 mt-4 ">
                  <svg
                    width="26"
                    height="30"
                    viewBox="0 0 26 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24.1991 17.137V2.49795C24.1991 2.12819 24.0523 1.77357 23.7908 1.51211C23.5293 1.25065 23.1747 1.10376 22.805 1.10376H3.28628C2.91652 1.10376 2.5619 1.25065 2.30044 1.51211C2.03898 1.77357 1.89209 2.12819 1.89209 2.49795V27.5934C1.89209 27.9631 2.03898 28.3178 2.30044 28.5792C2.5619 28.8407 2.91652 28.9876 3.28628 28.9876H10.9543M8.16595 6.68052H17.9253M8.16595 12.2573H17.9253M8.16595 17.8341H12.3485"
                      stroke="#27295B"
                      strokeWidth="2"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M23.5023 28.9873L21.0869 26.5719M21.0869 26.5719C21.4172 26.2497 21.6804 25.8652 21.861 25.4406C22.0416 25.0159 22.136 24.5597 22.1389 24.0983C22.1418 23.6368 22.0531 23.1794 21.8778 22.7526C21.7025 22.3257 21.4443 21.9379 21.118 21.6116C20.7916 21.2854 20.4038 21.0272 19.9769 20.852C19.55 20.6768 19.0926 20.5881 18.6312 20.591C18.1698 20.594 17.7135 20.6885 17.2889 20.8692C16.8643 21.0498 16.4798 21.313 16.1577 21.6434C15.5089 22.2981 15.1458 23.1832 15.148 24.105C15.1501 25.0267 15.5173 25.9101 16.1692 26.5618C16.821 27.2135 17.7045 27.5804 18.6263 27.5823C19.5481 27.5842 20.433 27.2209 21.0876 26.5719H21.0869Z"
                      stroke="#27295B"
                      strokeWidth="2"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <p className="text-lg font-bold text-primary">Présentation</p>
                </div>
                <p className="text-base text-primary font-light mt-4">
                Le cabinet {data.length>0 && decodedStringValue(data[0]._source.name).toUpperCase()} est un cabinet d'expertise comptable et d'audit, situé au cœur de {data.length>0 && (decodedStringValue(data[0]._source.addresslocality).toLowerCase()=="paris" || decodedStringValue(data[0]._source.addresslocality).toLowerCase()=="lyon" || decodedStringValue(data[0]._source.addresslocality).toLowerCase()=="marseille") 

                ?` ${data.length>0 && parseInt(((data[0]._source.postalcode).toString()).slice(-2)) ==1?`(${parseInt(((data[0]._source.postalcode).toString()).slice(-2))}er arrondissement`:`${parseInt(((data[0]._source.postalcode).toString()).slice(-2))} ème arrondissement`} de ${data.length>0 && decodedStringValue(data[0]._source.addresslocality).toUpperCase()} (${data.length>0 && data[0]._source.postalcode})`
                :
                `${data.length>0 && decodedStringValue(data[0]._source.addresslocality).toUpperCase()} (${data.length>0 && data[0]._source.postalcode}).`
                }
                </p>
                <p className="text-base text-primary font-light mt-3">
                Notre cabinet se consacre à fournir des services de comptabilité et d’audit de qualité supérieure. Notre expertise est spécialement adaptée pour répondre aux besoins diversifiés des entreprises et des particuliers de ces grandes métropoles. Forts d’une équipe d’experts hautement qualifiés, nous nous engageons à offrir des conseils professionnels et un accompagnement sur mesure pour la réussite financière de nos clients.
                </p>
                {/* <button className="text-base font-medium text-black-light underline my-3">
                  Voir plus
                </button> */}
              </div>

              <div className="bg-white rounded-md p-6 mt-4" id={filterData[1].id}>
                <div className="flex gap-2 mt-4 ">
                  <img src={matries} alt="matries" />
                  <p className="text-lg font-bold text-primary">Métiers</p>
                </div>
                <div className="mt-4 flex gap-2 items-center flex-wrap">
                  <div
                    className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                    style={{ background: "rgba(222, 227, 226, 0.5)" }}
                  >
                    Expert Comptable
                  </div>
                  <div
                    className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                    style={{ background: "rgba(222, 227, 226, 0.5)" }}
                  >
                    Commissaire aux comptes
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-md p-6 mt-4" id={filterData[2].id}>
                <div className="flex gap-2 mt-4">
                  <img src={Compétences} alt="" />
                  <p className="text-lg font-bold text-primary">Compétences</p>
                </div>
                <div className="mt-4 flex gap-2 items-center flex-wrap">
                  <div
                    className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                    style={{ background: "rgba(222, 227, 226, 0.5)" }}
                  >
                    Gestion de la paie{" "}
                  </div>
                  {/* <div
                    className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                    style={{ background: "rgba(222, 227, 226, 0.5)" }}
                  >
                    Commissaire à la fusion{" "}
                  </div>
                  <div
                    className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                    style={{ background: "rgba(222, 227, 226, 0.5)" }}
                  >
                    Commissaire à la fusion{" "}
                  </div>
                  <div
                    className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                    style={{ background: "rgba(222, 227, 226, 0.5)" }}
                  >
                    Comptabilité analylique
                  </div>
                  <div
                    className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                    style={{ background: "rgba(222, 227, 226, 0.5)" }}
                  >
                    Commissaire aux comptes{" "}
                  </div>
                  <div
                    className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                    style={{ background: "rgba(222, 227, 226, 0.5)" }}
                  >
                    Commissaire aux apports{" "}
                  </div>
                  <div
                    className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                    style={{ background: "rgba(222, 227, 226, 0.5)" }}
                  >
                    Comptabilité analylique
                  </div> */}
                </div>
              </div>

              <div className="bg-white rounded-md p-6 mt-4" id={filterData[3].id}>
                <div className="flex gap-2 mt-4">
                  <svg
                    width="31"
                    height="30"
                    viewBox="0 0 31 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.92198 19.3005V21.4256H7.79483L0.796875 28.4236L2.29932 29.926L9.29728 22.9281V27.8009H11.4224V19.3005H2.92198Z"
                      fill="#27295B"
                    />
                    <path
                      d="M14.6099 27.8009V25.6758C16.9615 25.673 19.2298 24.805 20.9826 23.2374C22.7354 21.6698 23.8501 19.5121 24.1144 17.1754H15.6725C15.109 17.1748 14.5688 16.9508 14.1704 16.5524C13.772 16.1539 13.5479 15.6137 13.5474 15.0503V6.60835C11.2107 6.87264 9.053 7.98741 7.48538 9.74021C5.91775 11.493 5.04982 13.7613 5.04698 16.1129H2.92188C2.92525 13.014 4.15775 10.0431 6.34895 7.85188C8.54016 5.66068 11.5111 4.42818 14.6099 4.4248C14.8917 4.4248 15.162 4.53675 15.3613 4.73602C15.5605 4.93529 15.6725 5.20555 15.6725 5.48735V15.0503H25.2354C25.5172 15.0503 25.7875 15.1623 25.9868 15.3615C26.186 15.5608 26.298 15.8311 26.298 16.1129C26.2946 19.2117 25.0621 22.1826 22.8709 24.3738C20.6797 26.565 17.7088 27.7975 14.6099 27.8009Z"
                      fill="#27295B"
                    />
                    <path
                      d="M29.4923 12.9254H19.9176C19.6389 12.9252 19.3628 12.8701 19.1054 12.7632C18.8479 12.6563 18.614 12.4997 18.4172 12.3023C18.2203 12.1049 18.0642 11.8707 17.958 11.6129C17.8517 11.3552 17.7973 11.079 17.7979 10.8003V1.23731C17.799 1.09629 17.8279 0.956887 17.883 0.827086C17.9382 0.697286 18.0184 0.579649 18.1191 0.480925C18.2198 0.382201 18.339 0.304335 18.4698 0.251795C18.6007 0.199255 18.7406 0.173076 18.8817 0.174759C21.9731 0.18373 24.9354 1.41579 27.1214 3.6018C29.3074 5.7878 30.5395 8.75009 30.5485 11.8416C30.5507 11.9822 30.5251 12.1219 30.4732 12.2526C30.4212 12.3833 30.344 12.5024 30.2458 12.6032C30.1477 12.7039 30.0305 12.7842 29.9012 12.8395C29.7719 12.8948 29.6329 12.924 29.4923 12.9254ZM19.923 10.8003H28.3649C28.1207 8.64549 27.1528 6.63728 25.6194 5.10386C24.0859 3.57045 22.0777 2.60253 19.923 2.3583V10.8003Z"
                      fill="#27295B"
                    />
                  </svg>

                  <p className="text-lg font-bold text-primary">
                    Secteurs d’activité
                  </p>
                </div>

                <div className="mt-4 flex gap-2 items-center flex-wrap">
                  <div
                    className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                    style={{ background: "rgba(222, 227, 226, 0.5)" }}
                  >
                    TPE -PME -ETI
                  </div>
                  {/* <div
                    className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                    style={{ background: "rgba(222, 227, 226, 0.5)" }}
                  >
                    Profession libérale{" "}
                  </div>
                  <div
                    className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                    style={{ background: "rgba(222, 227, 226, 0.5)" }}
                  >
                    Commerce
                  </div>
                  <div
                    className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                    style={{ background: "rgba(222, 227, 226, 0.5)" }}
                  >
                    E-Commerce
                  </div>
                  <div
                    className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                    style={{ background: "rgba(222, 227, 226, 0.5)" }}
                  >
                    Immobilier
                  </div>
                  <div
                    className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit"
                    style={{ background: "rgba(222, 227, 226, 0.5)" }}
                  >
                    Evénementiel
                  </div> */}
                </div>
              </div>

              <div className="bg-white rounded-md p-6 mt-4" id={filterData[4].id}>
                <div className="flex gap-2 mt-4">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8 22.58L10 20.58V23.42L7.7 25.7L6 25V20H3L2 19V3L3 2H27L28 3V12H26V4H4V18H7L8 19V22.58ZM20.58 26L24.3 29.7L26 29V26H29L30 25V15L29 14H13L12 15V25L13 26H20.58ZM21 24H14V16H28V24H25L24 25V26.58L21.7 24.3L21 24Z"
                      fill="#27295B"
                    />
                  </svg>
                  <p className="text-lg font-bold text-primary">Langues</p>
                </div>

                <div className="mt-4 flex gap-2 items-center flex-wrap">
                  {
                    data.length>0 && data[0]._source.languagesArr ?
                    data[0]._source.languagesArr.map((val,i)=>{
                      return <div  key={i} className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit">{val}</div>
                    })                
                    :""
                  }
                  {/* <div className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit">
                    Français
                  </div>
                  <div className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit">
                    Anglais
                  </div>
                  <div className="rounded-[30px] text-[15px] font-normal text-gray py-1 px-3 max-w-fit">
                    Espagnol
                  </div> */}
                </div>
              </div>

              <div className="flex flex-col xl:flex-row gap-2 mt-4" id={filterData[5].id}>
                <div className="bg-white rounded-md p-6  sm:min-w-[440px]">
                  <div className="flex gap-2 ">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1470_2793)">
                        <path
                          d="M15.8891 29.6111C12.2792 29.6111 8.81712 28.1771 6.26454 25.6245C3.71196 23.0719 2.27794 19.6099 2.27794 16C2.27794 12.3901 3.71196 8.92808 6.26454 6.3755C8.81712 3.82293 12.2792 2.3889 15.8891 2.3889C19.4989 2.3889 22.961 3.82293 25.5136 6.3755C28.0661 8.92808 29.5002 12.3901 29.5002 16C29.5002 19.6099 28.0661 23.0719 25.5136 25.6245C22.961 28.1771 19.4989 29.6111 15.8891 29.6111ZM15.8891 31.5556C20.0146 31.5556 23.9713 29.9167 26.8885 26.9995C29.8057 24.0822 31.4446 20.1256 31.4446 16C31.4446 11.8744 29.8057 7.91781 26.8885 5.00058C23.9713 2.08334 20.0146 0.444458 15.8891 0.444458C11.7635 0.444458 7.80685 2.08334 4.88961 5.00058C1.97238 7.91781 0.333496 11.8744 0.333496 16C0.333496 20.1256 1.97238 24.0822 4.88961 26.9995C7.80685 29.9167 11.7635 31.5556 15.8891 31.5556Z"
                          fill="#27295B"
                        />
                        <path
                          d="M17.6976 13.2544L13.2448 13.8125L13.0853 14.5514L13.9603 14.7128C14.532 14.8489 14.6448 15.055 14.5203 15.6247L13.0853 22.3681C12.7081 24.1122 13.2895 24.9328 14.6565 24.9328C15.7162 24.9328 16.947 24.4428 17.5051 23.77L17.6762 22.9611C17.2873 23.3033 16.7195 23.4394 16.3423 23.4394C15.8076 23.4394 15.6131 23.0642 15.7512 22.4031L17.6976 13.2544ZM17.8337 9.19444C17.8337 9.71014 17.6288 10.2047 17.2642 10.5694C16.8995 10.934 16.4049 11.1389 15.8892 11.1389C15.3735 11.1389 14.879 10.934 14.5143 10.5694C14.1496 10.2047 13.9448 9.71014 13.9448 9.19444C13.9448 8.67875 14.1496 8.18417 14.5143 7.81951C14.879 7.45486 15.3735 7.25 15.8892 7.25C16.4049 7.25 16.8995 7.45486 17.2642 7.81951C17.6288 8.18417 17.8337 8.67875 17.8337 9.19444Z"
                          fill="#27295B"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1470_2793">
                          <rect
                            width="31.1111"
                            height="31.1111"
                            fill="white"
                            transform="translate(0.333496 0.444458)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    <p className="text-lg font-bold text-primary">
                      Informations pratiques
                    </p>
                  </div>
                  <p className="font-light text-base text-black my-5">
                  {data.length>0 && decodedStringValue(data[0]._source.streetaddress).toLowerCase()} {data.length>0 && data[0]._source.postalcode} , {data.length>0 && decodedStringValue(data[0]._source.addresslocality).toUpperCase()} {/* {data.length>0 && data[0].addresscountry} */}
                  </p>
                  <p className="text-base font-normal text-primary">
                    Horaires d’ouverture
                  </p>
                  {
                    (data.length>0 && (data[0]._source.openingHoursArr).length>0)?
                    (data[0]._source.openingHoursArr).map((val,key)=>{
                      return <>
                        <div  key={key} className="flex justify-between flex-col sm:flex-row sm:items-center sm:gap-4 my-2">
                          <p className="text-base font-light text-black">{val.dayName} : </p>
                          <p className="text-base font-light text-black">
                          {val.openingHours}{" "}
                          </p>
                        </div>
                      </>
                    })
                    :
                    ""
                  }
                  {/* <div className="flex justify-between flex-col sm:flex-row sm:items-center sm:gap-4 my-2">
                    <p className="text-base font-light text-black">Lundi : </p>
                    <p className="text-base font-light text-black">
                      9h00 - 13h00, 14h00 - 18h00{" "}
                    </p>
                  </div>
                  <div className="flex justify-between flex-col sm:flex-row sm:items-center sm:gap-4 my-2">
                    <p className="text-base font-light text-black">Mardi :</p>
                    <p className="text-base font-light text-black">
                      9h00 - 13h00, 14h00 - 18h00{" "}
                    </p>
                  </div>
                  <div className="flex justify-between flex-col sm:flex-row sm:items-center sm:gap-4 my-2">
                    <p className="text-base font-light text-black">
                      Mercredi :
                    </p>
                    <p className="text-base font-light text-black">
                      9h00 - 13h00, 14h00 - 18h00{" "}
                    </p>
                  </div>
                  <div className="flex justify-between flex-col sm:flex-row sm:items-center sm:gap-4 my-2">
                    <p className="text-base font-light text-black">Jeudi :</p>
                    <p className="text-base font-light text-black">
                      9h00 - 13h00, 14h00 - 18h00{" "}
                    </p>
                  </div>
                  <div className="flex justify-between flex-col sm:flex-row sm:items-center sm:gap-4 my-2">
                    <p className="text-base font-light text-black">
                      Vendredi :
                    </p>
                    <p className="text-base font-light text-black">
                      9h00 - 13h00, 14h00 - 18h00{" "}
                    </p>
                  </div>
                  <div className="flex sm:items-center flex-col sm:flex-row  sm:gap-16 my-2">
                    <p className="text-base font-light text-black">Samedi :</p>
                    <p className="text-base font-light text-black sm:ml-10">
                      Fermé
                    </p>
                  </div> */}
                </div>
                <div style={{ width: "100%", height: "100%", minHeight: "365px" }}>
                {
                  data.length>0 && data[0]._source.longitude && data[0]._source.latitude?                
                  <Mapbox longitude={data[0]._source.longitude} latitude={data[0]._source.latitude } geoJson={geoJson} />
                : 
                  <Mapbox geoJson={geoJson} latitude={latlng.latitude} longitude={latlng.longitude} />
                }
                </div>
                {/* <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5666151.454104781!2d-3.2305647495523675!3d46.09744499642553!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd54a02933785731%3A0x6bfd3f96c747d9f7!2sFrance!5e0!3m2!1sen!2sin!4v1685359635891!5m2!1sen!2sin"
                  style={{ width: "100%", height: "100%", minHeight: "365px" }}
                  title="france"
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe> */}
              </div>
            </div>
            <div className="col-span-12 2lg:col-span-4  max-h-[100vh] sticky top-32 overflow-y-auto"  >
              <div
                className="col-span-12 2lg:col-span-4 p-8 rounded-3xl max-h-[350px]  bg-white"
                style={{
                  boxShadow: "-1px 1px 8px 4px rgba(195, 195, 195, 0.25)",
                }}
              >
                <div className="flex gap-5 items-center">
                  <img src={logo} className="w-14 h-14" alt={logo} />
                  <div>
                    <h6 className="text-[18px] font-medium text-primary">
                      {data.length>0 && decodedStringValue(data[0]._source.name).toUpperCase()}
                    </h6>
                    <div className="flex gap-2 items-center">
                      <svg
                        width="15"
                        height="19"
                        viewBox="0 0 15 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.75 7.07333C0.75 3.60173 3.65478 0.75 7.28486 0.75C10.9149 0.75 13.8197 3.60173 13.8197 7.07332C13.8197 7.60098 13.7447 8.22369 13.5918 8.81093C13.4366 9.40654 13.2157 9.91033 12.9584 10.2414L13.5506 10.7016L12.9584 10.2414L7.28486 17.5422L1.61133 10.2414C1.00271 9.45821 0.75 8.30502 0.75 7.07333ZM11.1005 7.07331C11.1005 4.99473 9.37095 3.3467 7.28486 3.3467C5.19877 3.3467 3.46923 4.99473 3.46923 7.07333C3.46923 9.15192 5.19877 10.7999 7.28486 10.7999C9.37095 10.7999 11.1005 9.15192 11.1005 7.07331Z"
                          fill="white"
                          stroke="#27295B"
                          strokeWidth="1.5"
                        />
                      </svg>
                      <p className="text-[15px] font-normal text-primary">
                      {/* {data.length>0 && decodedStringValue(data[0].streetaddress)}  */}{data.length>0 && decodedStringValue(data[0]._source.addresslocality).toUpperCase()} {data.length>0 && "("+data[0]._source.postalcode+")"}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col justify-between items-center mt-8 gap-4">
                  <button className="w-full h-full min-h-[50px] flex items-center justify-center gap-3 bg-primary text-white text-base font-semibold rounded-md transition-all duration-300 hover:bg-secondary" onClick={(e)=>handleOpenMessage(e,data.length>0 ?data[0]._source:"")}>
                    <img src={messages} alt="messages" />
                    Message
                  </button>
                  <button className="w-full h-full min-h-[50px] flex items-center justify-center gap-3 border border-primary text-primary text-base font-semibold rounded-md transition-all duration-300 hover:bg-secondary hover:text-white " onClick={(e)=>handleOpenMessage(e,data.length>0 ?data[0]._source:"")}>
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="rotate_telephone"
                    >
                      <path
                        d="M24.7709 4.02222L21.3228 0.644445C20.9019 0.231746 20.3386 0 19.7429 0C19.1472 0 18.5838 0.228572 18.1629 0.644445L14.4494 4.27937C14.0285 4.69206 13.7922 5.24762 13.7922 5.83175C13.7922 6.41905 14.0253 6.96825 14.4494 7.38413L17.3503 10.2317C16.6895 11.7415 15.7399 13.1133 14.553 14.273C13.3648 15.4444 11.9759 16.3683 10.4348 17.0222L7.5339 14.1746C7.11301 13.7619 6.54966 13.5302 5.95395 13.5302C5.66011 13.5291 5.36902 13.5855 5.09772 13.6962C4.82642 13.8069 4.58037 13.9695 4.374 14.1746L0.657233 17.8095C0.236345 18.2222 0 18.7778 0 19.3619C0 19.9492 0.233107 20.4984 0.657233 20.9143L4.10204 24.2921C4.82079 24.9968 5.81149 25.4 6.8281 25.4C7.03854 25.4 7.24251 25.3841 7.44972 25.3492C11.7363 24.6571 15.9905 22.4191 19.4256 19.054C22.8575 15.6825 25.1367 11.5111 25.849 7.30476C26.053 6.11111 25.645 4.88254 24.7709 4.02222ZM23.5535 6.92698C22.9222 10.6698 20.8696 14.4032 17.7777 17.4349C14.6858 20.4667 10.8816 22.4794 7.06444 23.0984C6.58528 23.1778 6.09316 23.0191 5.7435 22.6794L2.36021 19.3619L5.94747 15.8413L9.82612 19.6508L9.85526 19.6794L10.5546 19.4254C12.675 18.661 14.6005 17.4536 16.1977 15.8869C17.7949 14.3203 19.0255 12.4318 19.8044 10.3524L20.0634 9.66667L16.1524 5.83492L19.7396 2.31429L23.1229 5.63175C23.4726 5.9746 23.6345 6.45714 23.5535 6.92698Z"
                        fill="currentcolor"
                      />
                    </svg>
                    Contacter
                  </button>
                  {/* <button className="w-full h-full min-h-[50px] flex items-center justify-center gap-3 border border-primary text-primary text-base font-semibold rounded-md transition-all duration-300 hover:bg-secondary hover:text-white">
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.8733 4.66675H6.95783C4.39606 4.66675 2.31934 6.75609 2.31934 9.33341V21.0001C2.31934 23.5774 4.39606 25.6667 6.95783 25.6667H20.8733C23.4351 25.6667 25.5118 23.5774 25.5118 21.0001V9.33341C25.5118 6.75609 23.4351 4.66675 20.8733 4.66675Z"
                        stroke="currentcolor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9.27708 2.33337V7.00004M18.5541 2.33337V7.00004M2.31934 11.6667H25.5118"
                        stroke="currentcolor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Prendre RDV
                  </button> */}
                </div>
              </div>
              <div
                className={`${data.length>0  && data[0]._source.claim_verified ?"hidden":"mt-5 col-span-12 2lg:col-span-4 p-8 rounded-3xl min-h-[350px] h-auto  bg-white"}`}
                style={{
                  boxShadow: "-1px 1px 8px 4px rgba(195, 195, 195, 0.25)",
                }}
              >
                <div className="flex gap-5 items-center">                  
                  <div>
                    <h6 className="text-[18px]  text-center font-medium text-primary">
                      Est-ce votre Cabinet Comptable ?
                    </h6>
                    <div className="flex gap-2 items-center">                      
                      <p className="text-[15px]  text-center font-normal text-primary">
                      Revendiquez cette page pour pouvoir facilement éditer ses informations.
                      </p>
                    </div>
                    <div  className="flex gap-5 items-center mt-4">
                      <img src={undraw_Design} className="w-25  text-center" alt={logo} />
                    </div>
                    <div className="flex gap-5 items-center mt-4">
                      <Link to={
                        {pathname:`/formulaire-inscription-pro/accountant/${name}/${data.length>0 ?data[0]._source.id:0}`,
                        state: { name: name}
                        }}  className="w-full h-full min-h-[50px] flex items-center justify-center gap-3 bg-primary text-white text-base font-semibold rounded-md transition-all duration-300 hover:bg-secondary" >
                      <EditNoteIcon />
                      Compléter cette page
                    </Link>
                    </div>
                  </div>
                </div> 
              </div>    
            </div>
            
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
